var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as actions from '../actions';
export function userReducer(state, action) {
  if (state === void 0) {
    state = {};
  }

  var payload = action.payload;

  switch (action.type) {
    case actions.LOGIN_SUCCESS:
    case actions.GET_PRIVILEGE_SUCCESS:
      return __assign(__assign({}, state), payload);

    case actions.LOGOUT_SUCCESS:
      return {};

    default:
      return state;
  }
}